import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1545009850674181';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    // Defer to after first paint so a failing tracker can never crash the app
    const id = window.setTimeout(() => {
      try {
        // Already loaded? Just fire a PageView and bail.
        if (window.fbq) {
          try {
            window.fbq('track', 'PageView');
          } catch {}
          return;
        }
        // Standard Meta Pixel base snippet (defensive port)
        const f: any = window;
        const b: Document = document;
        const n: any = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        f.fbq = n;
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement('script') as HTMLScriptElement;
        t.async = true;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        // Swallow load errors silently (ad-blockers, sandboxed iframes, etc.)
        t.onerror = () => {};
        const head = b.head || b.getElementsByTagName('head')[0];
        if (head) {
          head.appendChild(t);
        } else {
          const s = b.getElementsByTagName('script')[0];
          if (s && s.parentNode) {
            s.parentNode.insertBefore(t, s);
          } else {
            // No anchor point — abort cleanly
            return;
          }
        }
        window.fbq('init', PIXEL_ID);
        window.fbq('track', 'PageView');
      } catch (err) {
        // Never let pixel setup break the page
        // eslint-disable-next-line no-console
        console.warn('Meta Pixel setup skipped:', err);
      }
    }, 0);
    return () => window.clearTimeout(id);
  }, []);
  return <noscript data-id="element-19">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-20" />
    </noscript>;
}
export function trackInitiateCheckout(plan: string, value: number) {
  if (typeof window === 'undefined') return;
  try {
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: plan,
        currency: 'ARS',
        value
      });
    }
  } catch {
    // ignore
  }
}